/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Wipe_Warning_BeforeInputs */

const fr_vehicle_action_archive_wipe_warning_before = /** @type {(inputs: Vehicle_Action_Archive_Wipe_Warning_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cocher la case ci-dessous `)
};

const en_vehicle_action_archive_wipe_warning_before = /** @type {(inputs: Vehicle_Action_Archive_Wipe_Warning_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the box below `)
};

/**
* | output |
* | --- |
* | "Check the box below" |
*
* @param {Vehicle_Action_Archive_Wipe_Warning_BeforeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_wipe_warning_before = /** @type {((inputs?: Vehicle_Action_Archive_Wipe_Warning_BeforeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Wipe_Warning_BeforeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_wipe_warning_before(inputs)
	return en_vehicle_action_archive_wipe_warning_before(inputs)
});